// ui/scoring-table.js: one shared Euchre scoring table.
//
// The go-alone confirmation (bidding-logic.js) and the How to Play
// scoring list (HowToPlayView.jsx) both build their numbers from this
// table, so the two cannot drift. A loner who is euchred scores nothing;
// the DEFENDERS get 2 (standard Euchre, not −2 to the loner).

export const SCORING_TABLE = Object.freeze({
  // Makers take 3-4 tricks.
  makersMade: Object.freeze({ tricks: '3–4', points: 1 }),
  // Makers take all 5 (a march).
  makersMarch: Object.freeze({ tricks: 'all 5', points: 2 }),
  // Makers take fewer than 3 (euchred): the defenders score.
  euchred: Object.freeze({ defendersPoints: 2 }),
  // Loner takes all 5.
  lonerSweep: Object.freeze({ tricks: 'all 5', points: 4 }),
  // Loner takes 3-4.
  lonerMade: Object.freeze({ tricks: '3–4', points: 1 }),
});

/**
 * The go-alone confirmation line. Built from SCORING_TABLE so a scoring
 * change updates it too.
 *
 * @returns {string}
 */
export function goAloneConfirmationText() {
  const t = SCORING_TABLE;
  return 'Going alone. Partner sits out. '
    + `Win all 5 → +${t.lonerSweep.points}. `
    + `Win 3–4 → +${t.lonerMade.points}. `
    + `Euchred → they get +${t.euchred.defendersPoints}.`;
}

/**
 * The How to Play scoring list, same numbers as the confirmation.
 * Each entry is a lead plus the bold points label HowToPlayView renders.
 *
 * @returns {Array<{ lead: string, points: string }>}
 */
export function howToPlayScoringLines() {
  const t = SCORING_TABLE;
  return [
    { lead: `Makers take ${t.makersMade.tricks} tricks → `, points: `${t.makersMade.points} point` },
    { lead: `Makers take ${t.makersMarch.tricks} (a march) → `, points: `${t.makersMarch.points} points` },
    {
      lead: 'Makers fail to take 3 (euchred) → opponents score ',
      points: `${t.euchred.defendersPoints} points`,
    },
    { lead: `Loner takes ${t.lonerSweep.tricks} → `, points: `${t.lonerSweep.points} points` },
    { lead: `Loner takes ${t.lonerMade.tricks} → `, points: `${t.lonerMade.points} point` },
  ];
}
